<template>
  <div class="p-6">
    <a-form layout="inline" :form="form" class="form-label-4">
      <a-form-item label="日期">
        <a-range-picker format="YYYY-MM" :value="month" :mode="mode" @panelChange="panelChange" @change="monthChange"
          @openChange="openChange" />
      </a-form-item>
      <a-form-item label="项目">
        <a-select-pro class="form-control" v-decorator="['projectCode']" placeholder="请选择" allowClear showSearch
          :options="projectList" @change="doQuery(1)" :dropdownMatchSelectWidth="false"></a-select-pro>
      </a-form-item>
      <a-form-item label="班组">
        <a-select-pro class="form-control" v-decorator="['leaderId']" placeholder="请选择" allowClear showSearch
          :options="leaderList" @change="doQuery(1)"></a-select-pro>
      </a-form-item>
    </a-form>

    <br />
    <div style="display: flex; align-items: flex-start; gap: 20px;">
      <div class="warning-text-inline" style="flex: 1; ">
        工人姓名：{{ this.userName }}
        &emsp;&emsp;&emsp;
        身份证号：{{ this.cardId }}
      </div>

      <div class="warning-text-inline" style="color: red; flex: 2;">
        特别说明：1、本表中本月实付金额，支付状态为成功时才表示已支付工人工资成功。
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        2、工资单类型为讨薪决策支付时背景色突出标记突出显示：支付金额大于0时为红色背景、支付金额等于0时橙色背景
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        3、工资单类型为虚增工友时背景色突出标记显示:粉色背景
      </div>
    </div>




    <div class="mt-6">
      <a-table rowKey="id" bordered :loading="loading" :columns="tableColumns" :dataSource="dataSource"
        :pagination="false" :scroll="{
          x: 1590,
        }" size="small" :customRow="customRow" :rowHoverable="false"></a-table>
      <table class="text-lg border-collapse" style="width: 70%; margin-top: 10px;">
        <thead>
          <tr>
            <th style="width: 180px; text-align: left; font-weight: normal; font-size: 16px; font-weight: bold;">汇总</th>
            <th style="width: 150px; text-align: left;">实际发放工资天数</th>
            <!-- <th style="width: 120px; text-align: left;">应发金额/元</th> -->
            <th style="width: 140px; text-align: left;">工人借支金额/元</th>
            <th style="width: 80px; text-align: left;">实付/元</th>
            <!-- <th style="width: 140px; text-align: left;">剩余欠付金额/元</th> -->
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 180px; white-space: nowrap; text-align: left; font-size: 16px;">合计数据</td>
            <td style="text-align: left;"><span class="text-black">{{ actualAttendanceDaysSum }}</span></td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ needPayAmountSum }}</span></td> -->
            <td style="text-align: left;"><span class="text-black">{{ repayAmountSum }}</span></td>
            <td style="text-align: left;"><span class="text-black">{{ actualPayAmountSum }}</span></td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ hasAmountSum }}</span></td> -->
          </tr>
          <tr>
            <td style="width: 180px; white-space: nowrap; text-align: left; font-size: 16px;">其中：工资表归档数据</td>
            <td style="text-align: left;"><span class="text-black">{{ archivedActualAttendanceDays }}</span></td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ archivedNeedPayAmount }}</span></td> -->
            <td style="text-align: left;"><span class="text-black">{{ archivedRepayAmount }}</span></td>
            <td style="text-align: left;"><span class="text-black">{{ archivedActualPayAmount }}</span></td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ archivedHasAmount }}</span></td> -->
          </tr>
          <tr>
            <td style="width: 180px; white-space: nowrap; text-align: left; font-size: 16px;">其中：工资表在途数据</td>
            <td style="text-align: left;"><span class="text-black">{{ transitActualAttendanceDays }}</span></td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ transitNeedPayAmount }}</span></td> -->
            <td style="text-align: left;"><span class="text-black">{{ transitRepayAmount }}</span></td>
            <td style="text-align: left;"><span class="text-black">{{ transitActualPayAmount }}</span></td>
            <!-- <td style="text-align: left;"><span class="text-black">{{ transitHasAmount }}</span></td> -->
          </tr>
        </tbody>
      </table>
      <base-pagination class="mt-6" :totalCount.sync="totalCount" :pageNo.sync="pageNo" :pageSize.sync="pageSize"
        @change="pageChange" size="small" />
    </div>
    <OaDocModal ref="oaDocModal"></OaDocModal>
  </div>
</template>

<script>
import { getProjectListByCard, getLeaderListByCard } from '@/service/getData'
import { queryViewMixin } from '@/utils/mixin'

import ASelectPro from '@/components/SelectPro.vue'
import OaDocModal from './OaDocModal.vue'

export default {
  components: {
    ASelectPro,
    OaDocModal,
  },
  mixins: [queryViewMixin],
  data() {
    const tableColumns = [
      {
        title: '工资月份',
        width: 80,
        align: 'center',
        dataIndex: 'salaryMonth',
        fixed: 'left',
      },
      {
        title: '项目',
        width: '8%',
        align: 'left',
        dataIndex: 'projectName',
      },
      {
        title: '班组',
        width: '5%',
        align: 'center',
        dataIndex: 'leaderName',
      },
      {
        title: '工资单号',
        width: '5%',
        align: 'left',
        dataIndex: 'salaryCode',
      },
      {
        title: '流程状态',
        width: '5%',
        align: 'center',
        dataIndex: 'wfStatus',
      },
      {
        title: '工资单发放通道',
        width: '5%',
        align: 'center',
        dataIndex: 'salaryChannel',
      },
      {
        title: '工资单类型',
        width: '5%',
        align: 'center',
        dataIndex: 'salaryType',
      },
      {
        title: '应发考勤天数',
        width: '5%',
        align: 'center',
        dataIndex: 'attendanceDays',
      },
      {
        title: '实际发放工资天数',
        width: '5%',
        align: 'center',
        dataIndex: 'actualAttendanceDays',
      },
      // {
      //   title: '应发金额/元',
      //   width: '5%',
      //   align: 'center',
      //   dataIndex: 'needPayAmount',
      // },
      {
        title: '偿还班组借支金额/元',
        width: '5%',
        align: 'center',
        dataIndex: 'repayAmount',
      },
      {
        title: '本月实付/元',
        width: '5%',
        align: 'center',
        dataIndex: 'actualPayAmount',
      },
      // {
      //   title: '本月欠付/元',
      //   width: '5%',
      //   align: 'center',
      //   dataIndex: 'unpaidAmount',
      // },
      {
        title: '支付单号',
        width: '5%',
        align: 'left',
        dataIndex: 'paymentCode',
      },
      {
        title: '支付账号',
        width: '8%',
        align: 'left',
        dataIndex: 'paymentAcoount',
      },
      {
        title: '支付状态',
        width: '5%',
        align: 'center',
        dataIndex: 'paymentStatus',
      },
      {
        title: '支付日期',
        width: '6%',
        align: 'left',
        dataIndex: 'paymentDate',
      },
      {
        title: '支付流水号',
        width: '5%',
        align: 'center',
        dataIndex: 'paymentNum',
      },
      {
        title: '银行回单号',
        width: '5%',
        align: 'center',
        dataIndex: 'bankReceiptNum',
      },
      {
        title: '操作',
        width: 120,
        align: 'center',
        customRender: (text, row) => {
          return (
            <div>
              <div>
                {row.originCertificate ? (
                  <a
                    onClick={() => {
                      this.checkCert(row)
                    }}
                  >
                    查看原始凭证
                  </a>
                ) : (
                  <span class="text-gray-400">查看原始凭证</span>
                )}
              </div>
              <div>
                {row.receiptFileList.length ? (
                  <a
                    onClick={() => {
                      this.checkReceipt(row)
                    }}
                  >
                    查看收条
                  </a>
                ) : (
                  <span class="text-gray-400">查看收条</span>
                )}
              </div>
              <div>
                {row.promiseBookFileList.length ? (
                  <a
                    onClick={() => {
                      this.checkCommitment(row)
                    }}
                  >
                    查看班组承诺书
                  </a>
                ) : (
                  <span class="text-gray-400">查看班组承诺书</span>
                )}
              </div>
            </div>
          )
        },
      },
    ]
    return {
      form: this.$form.createForm(this),
      pageNo: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      tableColumns: tableColumns,
      dataSource: [],

      projectList: [],
      leaderList: [],
      month: [],
      mode: ['month', 'month'],

      attendanceDaysSum: 0,
      actualAttendanceDaysSum: 0,
      needPayAmountSum: 0,
      repayAmountSum: 0,
      actualPayAmountSum: 0,
      unpaidAmountSum: 0,
      offAmountSum: 0,
      hasAmountSum: 0,

      archivedActualAttendanceDays: '',
      archivedNeedPayAmount: '',
      archivedRepayAmount: '',
      archivedActualPayAmount: '',
      archivedHasAmount: '',

      transitActualAttendanceDays: '',
      transitNeedPayAmount: '',
      transitRepayAmount: '',
      transitActualPayAmount: '',
      transitHasAmount: '',

      cardId: '',
      userName: '',
    }
  },
  methods: {
    customRow(record) {
      if (record.salaryType === '讨薪决策') {
        // 将实际支付金额转换为数字进行比较
        const actualPayAmount = parseFloat(record.actualPayAmount) || 0
        if (actualPayAmount > 0) {
          return {
            style: {
              background: '#f44336',
              color: '#ffffff'
            },
            class: 'red-row',
            // 直接在JS中处理悬停事件
            on: {
              mouseenter: (e) => {
                e.currentTarget.style.backgroundColor = '#f44336'
                e.currentTarget.style.color = '#ffffff'
                const cells = e.currentTarget.querySelectorAll('td')
                cells.forEach(cell => {
                  cell.style.backgroundColor = '#f44336'
                  cell.style.color = '#ffffff'
                })
              },
              mouseleave: (e) => {
                e.currentTarget.style.backgroundColor = '#f44336'
                e.currentTarget.style.color = '#ffffff'
                const cells = e.currentTarget.querySelectorAll('td')
                cells.forEach(cell => {
                  cell.style.backgroundColor = '#f44336'
                  cell.style.color = '#ffffff'
                })
              }
            }
          }
        } else if (actualPayAmount === 0) {
          return {
            style: {
              background: '#ff8a65',
              color: '#ffffff'
            },
            class: 'light-red-row',
            // 直接在JS中处理悬停事件
            on: {
              mouseenter: (e) => {
                e.currentTarget.style.backgroundColor = '#ff8a65'
                e.currentTarget.style.color = '#ffffff'
                const cells = e.currentTarget.querySelectorAll('td')
                cells.forEach(cell => {
                  cell.style.backgroundColor = '#ff8a65'
                  cell.style.color = '#ffffff'
                })
              },
              mouseleave: (e) => {
                e.currentTarget.style.backgroundColor = '#ff8a65'
                e.currentTarget.style.color = '#ffffff'
                const cells = e.currentTarget.querySelectorAll('td')
                cells.forEach(cell => {
                  cell.style.backgroundColor = '#ff8a65'
                  cell.style.color = '#ffffff'
                })
              }
            }
          }
        }
      } else if (record.salaryType === '虚增工友') {
        return {
          style: {
            background: '#ffc8ff',
            color: '#000000'
          },
          class: 'purple-row',
          on: {
            mouseenter: (e) => {
              e.currentTarget.style.backgroundColor = '#ffc8ff'
              e.currentTarget.style.color = '#000000'
              const cells = e.currentTarget.querySelectorAll('td')
              cells.forEach(cell => {
                cell.style.backgroundColor = '#ffc8ff'
                cell.style.color = '#000000'
              })
            },
            mouseleave: (e) => {
              e.currentTarget.style.backgroundColor = '#ffc8ff'
              e.currentTarget.style.color = '#000000'
              const cells = e.currentTarget.querySelectorAll('td')
              cells.forEach(cell => {
                cell.style.backgroundColor = '#ffc8ff'
                cell.style.color = '#000000'
              })
            }
          }
        }
      }
      return {}
    },
    async doQuery(_pageNo = this.pageNo, _pageSize = this.pageSize) {
      this.loading = true
      try {
        await this.$nextTick()
        const params = {
          ...this.getPageParams(_pageNo, _pageSize),
          cardId: this.$route.query.cardId,
          month: this.month,
        }

        const res = await this.$axios.post(
          '/report/evidence/chain/salary/list',
          this.formatTimeRangeParams(params, 'month', { format: 'YYYY-MM' })
        )
        const { pageSize, pageNo, totalCount, list } = res.data
        this.totalCount = totalCount
        this.pageSize = pageSize
        this.pageNo = pageNo
        this.dataSource = list
        this.attendanceDaysSum = res.data.attendanceDaysSum
        this.actualAttendanceDaysSum = res.data.actualAttendanceDaysSum
        this.needPayAmountSum = res.data.needPayAmountSum
        this.repayAmountSum = res.data.repayAmountSum
        this.actualPayAmountSum = res.data.actualPayAmountSum
        this.unpaidAmountSum = res.data.unpaidAmountSum
        this.offAmountSum = res.data.offAmountSum
        this.hasAmountSum = res.data.hasAmountSum

        // 归档数据
        this.archivedActualAttendanceDays = res.data.archivedActualAttendanceDays
        this.archivedNeedPayAmount = res.data.archivedNeedPayAmount
        this.archivedRepayAmount = res.data.archivedRepayAmount
        this.archivedActualPayAmount = res.data.archivedActualPayAmount
        this.archivedHasAmount = res.data.archivedHasAmount

        // 在途数据
        this.transitActualAttendanceDays = res.data.transitActualAttendanceDays
        this.transitNeedPayAmount = res.data.transitNeedPayAmount
        this.transitRepayAmount = res.data.transitRepayAmount
        this.transitActualPayAmount = res.data.transitActualPayAmount
        this.transitHasAmount = res.data.transitHasAmount
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    panelChange(month, mode) {
      this.month = month
      this.mode = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]]
    },
    monthChange(month) {
      this.month = month
      this.doQuery(1)
    },
    openChange(open) {
      if (!open) {
        this.doQuery(1)
      }
    },
    async openOssUrl(ossUrl) {
      const res = await this.$axios.post('/report/evidence/chain/tmp/pathUrl', {
        ossUrl,
      })
      const url = res.data
      window.open(url)
    },
    checkCert(row) {
      this.openOssUrl(row.originCertificate)
    },
    checkReceipt(row) {
      this.$refs.oaDocModal.start(row.receiptFileList)
    },
    checkCommitment(row) {
      this.$refs.oaDocModal.start(row.promiseBookFileList)
    },
  },
  async mounted() {
    const { cardId, projectCode, leaderId } = this.$route.query
    const param = { cardId, projectCode, leaderId }
    const res = await this.$axios.post(`/report/evidence/chain/worker/Info`, param)
    this.userName = res.data.username
    this.cardId = cardId

    this.projectList = await getProjectListByCard({ cardId })
    this.leaderList = await getLeaderListByCard({ cardId })
    this.doQuery()
  },
}
</script>

<style lang="less" scoped>
/* 简化样式，移除 :global 选择器 */
/* 悬停效果已在 JavaScript 中处理 */
</style>
